module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/chevron-left-double-small-40eb85cb16c63af00a53d070446682f8.svg";